import { Events, Properties } from '../../enums/Analytics';
import Analytics from '../../tools/Analytics';

export const trackSignIn = (method: string, referrer?: string) => {
  Analytics.track(Events.ACCOUNT_LOGGED_IN, {
    [Properties.AUTHENTICATION]: method,
    [Properties.ENTERED_FROM]: referrer,
  });
};
